import createAccountUserSearchDialogTemplate from './dialog/create-account-user-search-dialog.html';
import CreateAccountUserSearchDialogController from './dialog/create-account-user-search-dialog-controller';

@Inject('Notifications')
export class RetailerGroupsExistingUserFieldController {
  constructor() {
    if (this.user && this.user.assignedUser) {
      this.selectedUser = this.user.assignedUser;
    }
  }

  showUserSearch() {
    this.Notifications.showComplexDialog({
      template: createAccountUserSearchDialogTemplate,
      controller: CreateAccountUserSearchDialogController,
    }).result.then((selectedUser) => {
      this.selectedUser = selectedUser;
      this.user.ownerUserId = selectedUser.id;
    });
  }

  clearSelectedUser() {
    this.selectedUser = null;
    this.user.ownerUserId = null;
    this.user.assignedUser = null;
  }
}



// WEBPACK FOOTER //
// ./src/modules/retailer-groups/components/existing-user-field/retailer-groups-existing-user-field-controller.js